//#region src/kiosk_os.ts
var KioskOs = /* @__PURE__ */ function(KioskOs) {
	KioskOs["Android"] = "Android";
	KioskOs["iOS"] = "iOS";
	KioskOs["Tizen"] = "Tizen";
	KioskOs["ChromeOS"] = "ChromeOS";
	return KioskOs;
}(KioskOs || {});
//#endregion
export { KioskOs };

//# sourceMappingURL=kiosk_os.js.map